import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  forwardRef,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { PaginationConfig } from '../../../shared/configs';
import { IPagination } from '../../../shared/interfaces';
import { IWarehouseGroup } from '../../../shared/interfaces/location-warehouse.interface';
import { LocationWarehouseGroupApiService } from '../../../shared/services/api/location/location-warehouse-group-api.service';

@Component({
  selector: 'lum-location-warehouse-group-control',
  templateUrl: './location-warehouse-group-control.component.html',
  styleUrls: ['./location-warehouse-group-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LocationWarehouseGroupControlComponent),
      multi: true,
    },
  ],
})
export class LocationWarehouseGroupControlComponent implements OnInit {
  @Input()
  inputClass :string = 'lum-input';

  @Input()
  externalParams :{ [param :string] :string | string[] } = {};

  @Input()
  disabled :boolean = false;

  warehouseGroups$ :Observable<IWarehouseGroup[]>;
  pagination$ :Observable<IPagination>;
  loading$ :Observable<boolean>;

  paginationConfig = PaginationConfig;
  queryParams :{
    [param :string] :string | string[];
  } = {};

  private onDestroy$ = new Subject();
  private onChange :any = () => {};
  private onTouched :any = () => {};

  private selectedWarehouseGroup :IWarehouseGroup;
  public displayValue :string;
  public warehouseGroups :IWarehouseGroup[] = [];

  constructor(
    private warehouseGroupService :LocationWarehouseGroupApiService,
    private changeDetectorRef :ChangeDetectorRef,
  ) {}

  writeValue(value :any) :void {
    if (!value || value === null) {
      return;
    }
    this.getById(value);
  }

  registerOnChange(fn :any) :void {
    this.onChange = fn;
  }

  registerOnTouched(fn :any) :void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled :boolean) :void {
    // You can implement this if you need to handle disabling the component
  }

  ngOnInit() :void {
    this.initQueryParams();
    this.getDataFromService();
    this.loadWarehouseGroups();
  }

  onSelectEvent(selectedWarehouseGroup :IWarehouseGroup) {
    if (
      this.selectedWarehouseGroup &&
      this.selectedWarehouseGroup.id === selectedWarehouseGroup.id
    ) {
      return;
    }
    this.displayValue = selectedWarehouseGroup.label;
    this.selectedWarehouseGroup = selectedWarehouseGroup;
    this.onChange(this.selectedWarehouseGroup.id);
  }

  resetValues() {
    this.onChange(null);
  }

  onChangeEvent(keyword :string) {
    this.resetValues();
    this.warehouseGroupService.get({
      ...this.queryParams,
      ...{ searchQuery: keyword },
    });
  }

  getById(id :number) {
    this.warehouseGroupService
      .getById(id)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (record :IWarehouseGroup) => {
          this.onSelectEvent(record);
          this.changeDetectorRef.detectChanges();
        },
        error: (e) => {},
      });
  }

  private initQueryParams() :void {
    this.queryParams = {
      limit: PaginationConfig.perPage.toString(),
      page: PaginationConfig.page.toString(),
      ...this.externalParams,
    };
  }

  private getDataFromService() :void {
    this.warehouseGroupService.warehouseGroups$.subscribe({
      next: (warehouseGroups :IWarehouseGroup[]) => {
        this.warehouseGroups = warehouseGroups;
      },
    });
    this.loading$ = this.warehouseGroupService.loading$;
    this.pagination$ = this.warehouseGroupService.pagination$;
  }

  private loadWarehouseGroups() :void {
    this.warehouseGroupService.get(this.queryParams);
  }
}
